import { gql } from '@apollo/client';
export const GET_BRANDS = gql`
  query getCustomerBrands {
    brands @rest(type: "Brand", path: "/v4/brands") {
      id
      name
      page_id
      default_primary_color
      default_secondary_color
      default_tertiary_color
      default_recruiter
      default_language_id
      default_logo
      default_creatives
      default_locations
      default_display_link
      default_banner_title
      # SYM-5856 / SYM-5789: a field absent here is STRIPPED by Apollo even when the API
      # returns it, so the brand form would load an empty control and overwrite the stored
      # value on the next save. Both must be listed.
      default_cta
      default_accent_color
      default_facebook_page_id
      salary_mandatory
      custom_domain
      custom_domain_validations
    }
  }
`;
